// 加工效果质量的两套口径 —— prism 迁移 0048 起在同一列并存 (后端 material-library assetprism/quality.go):
//   v1 现象词表  best / good / acceptable / poor               配 score 0–100 + defects[] 缺陷码
//   v2 加工质量评估  perfect / minor_flaw / abnormal / unjudgable   配 indicators[] 核心指标 + unable_reason
// 历史行是 v1, 新打的是 v2; 一行是哪套只看 quality 落在哪个集合 (别靠 score 是否为空).
// 徽标文案/配色在 parts.tsx (QUALITY_LABEL / TIER3 / EffectBadge); 这里是纯数据与归并函数.

export const QUALITY_V1 = ['best', 'good', 'acceptable', 'poor'] as const;
export const QUALITY_V2 = ['perfect', 'minor_flaw', 'abnormal', 'unjudgable'] as const;
export const isV2Quality = (q: string | undefined | null) => !!q && (QUALITY_V2 as readonly string[]).includes(q);
// v2「无法判断」原因码 (prism UNABLE_REASON_PRIORITY).
export const UNABLE_REASON_LABEL: Record<string, string> = {
    high_reflection: '图片高反光，加工区域被反光或强光斑盖住',
    blurry: '图片不清晰：模糊、失焦、曝光不足或过曝',
    no_material: '画面里没有材料，或看不到本次加工出来的内容',
    other: '其他原因',
};
// v2 核心指标词表 (《图像采集表》, 按工艺相加 19 项、去重 18 个; 与 prism quality_vocab.json 逐字一致). key = archive 的 craft.
// 范围外的工艺 (切割等) 不判指标, 只记结论. ⚠ 词表是采集表的生成物, 会变: 这里只给复核表单当选项,
// 展示侧 (effect.indicators) 不按它过滤, 认不出的名字照样显示; prism 重跑词表后要同步 (后端 assetprism/quality.go 同).
export const QUALITY_INDICATORS: Record<string, string[]> = {
    VECTOR_ENGRAVING: ['线条平直度', '连续性', '错位/重影', '端点质量', '深浅一致性', '拐角质量', '拼接错位（四轴必测）'],
    FILL_VECTOR_ENGRAVING: ['填充均匀性', '细节保真度', '元素一致性', '幅面一致性', '麻点', '拼缝（四轴必测）'],
    BITMAP_ENGRAVING: ['清晰度', '灰阶还原', '噪点', '幅面与条纹', '拼缝（四轴）', '细节保真度'],
};

/** 后端八键分档 (两套口径各数各的). v2 四键在老后端上没有, 所以可选. */
export type QualityCounts = {
    best: number; good: number; acceptable: number; poor: number;
    perfect?: number; minor_flaw?: number; abnormal?: number; unjudgable?: number;
};
/**
 * 八键 → 页面三档: 完美 = best + perfect, 轻微瑕疵 = good + minor_flaw, 不达标 = acceptable + poor + abnormal.
 * base 是各种比例的分母 = 三档之和; 「无法判断」单独给, 不进分母 (与 low_confidence 同一处理).
 * 所有分母 / 比例都从这里取, 别在页面上手写 best+good+... —— 那会把另一套口径的行漏掉且不报错.
 */
export function qualityTierCounts(e?: QualityCounts | null) {
    const n = (v?: number) => v ?? 0;
    const perfect = n(e?.best) + n(e?.perfect);
    const minor = n(e?.good) + n(e?.minor_flaw);
    const fail = n(e?.acceptable) + n(e?.poor) + n(e?.abnormal);
    const unjudgable = n(e?.unjudgable);
    return { perfect, minor, fail, unjudgable, base: perfect + minor + fail };
}
